function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#757575"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M22 17a1.5 1.5 0 0 1 1.5 1.5v12A1.5 1.5 0 0 1 22 32H2a1.5 1.5 0 0 1-1.5-1.5v-12A1.5 1.5 0 0 1 2 17h20zM22 .5A1.5 1.5 0 0 1 23.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2A1.5 1.5 0 0 1 2 .5h20z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1zm7-15.5h11.455M10 6h11.455M10 9h11.455M2.499 30.033h19M16.5 12.5h5m-19 0H14M16.5 28h5m-19 0H14"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.5 6C6.881 6 8 7.343 8 9H3c0-1.657 1.119-3 2.5-3zm0-3a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 5.5 3z"
}));

var SvgCnhListIcon = function SvgCnhListIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCnhListIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cnh_list_icon.14b20ea7.svg";
export { ForwardRef as ReactComponent };